import React from 'react';
import BlockedCard from './BlockedCard';
//import robots from '../robots'
import SearchBox from './SearchBox'

const BlockedCardList = ({robots,setTest,onRouteChange }) => {
	return (
		<div>
		{

		robots.map((user, i) =>{
		return (
		<BlockedCard
		onRouteChange = {onRouteChange} 
		setTest={setTest}
		key = {i} 
		id = {robots[i].id} 
		first_name = {robots[i].first_name}
		last_name = {robots[i].last_name} 
		gender = {robots[i].gender}
		email = {robots[i].email}
		rating = {robots[i].rating}
		image_key = {robots[i].image_key}
		rating_count = {robots[i].rating_count}
		/>
		);
		})
	}
		</div>
	);
}

export default BlockedCardList;